import React from 'react';
import Layout from '../../shared/components/Layout';
import Complete from '@/components/Complete';

const RegistrationComplete: React.FC = () => {
  return (
    <React.Fragment>
      <Layout>
        <Complete id="page-facility_login" heading="新規契約申込完了" content="新規契約申込が完了しました。"  />
      </Layout>
    </React.Fragment>
  )
}

export default RegistrationComplete;